module.exports = __webpack_public_path__ + "img/SET_NOYA_05_04.0ee33e4c.jpg";